(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/periods.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/periods.js');
'use strict';

const dates = svs.selfExclusion.dates;
const _svs$ui$ReactForm = svs.ui.ReactForm,
  ControlGroup = _svs$ui$ReactForm.ControlGroup,
  Select = _svs$ui$ReactForm.Select,
  Option = _svs$ui$ReactForm.Option;
const _svs$selfExclusion$Co = svs.selfExclusion.Constants,
  isPnp = _svs$selfExclusion$Co.isPnp,
  periodsLabelText = _svs$selfExclusion$Co.periodsLabelText;
const Periods = _ref => {
  let onHandlePeriod = _ref.onHandlePeriod,
    exclusionDates = _ref.exclusionDates,
    exclusions = _ref.exclusions,
    period = _ref.period,
    isSubmitted = _ref.isSubmitted;
  const allGamesExpiry = svs.selfExclusion.useAllExclusions(exclusions);
  const handleChange = periodValue => {
    const foundDate = dates.find(date => date.value === Number(periodValue));
    onHandlePeriod(foundDate);
  };
  return React.createElement(ControlGroup, {
    errorMessage: "Du m\xE5ste v\xE4lja en period",
    hasError: isSubmitted && !period,
    v2: true
  }, React.createElement("label", {
    className: "styled-label"
  }, periodsLabelText, React.createElement(Select, {
    id: "reactSelect",
    inverted: isPnp,
    onChange: e => handleChange(e.target.value),
    v2: true,
    value: (period === null || period === void 0 ? void 0 : period.value.toString()) || ''
  }, React.createElement(Option, null), exclusionDates.map(date => React.createElement(Option, {
    disabled: date.isExcluded || dateFns.isBefore(date.willExpire, allGamesExpiry),
    key: date.id,
    value: date.value.toString()
  }, date.text)))));
};
svs.selfExclusion.components.Periods = Periods;

 })(window);